package com.downdogapp.client.views

import com.downdogapp.*
import com.downdogapp.Border.NONE
import com.downdogapp.Display.FLEX
import com.downdogapp.FlexDirection.ROW
import com.downdogapp.FontWeight.*
import com.downdogapp.JustifyContent.SPACE_BETWEEN
import com.downdogapp.Size.AUTO
import com.downdogapp.Size.Companion.percent
import com.downdogapp.Size.Companion.px
import com.downdogapp.TextAlign.CENTER
import com.downdogapp.client.*
import com.downdogapp.client.api.GiftProduct
import com.downdogapp.client.controllers.PurchaseGiftViewController
import com.downdogapp.client.resources.Images
import com.downdogapp.client.resources.image
import com.downdogapp.client.views.PurchaseView.Companion.currencyCode
import com.downdogapp.client.widget.*
import com.downdogapp.client.widget.ScreenWidth.PHONE
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLSpanElement

class PurchaseGiftView(private val controller: PurchaseGiftViewController) : TopLevelView(), View {

  private var paymentOptionViewContainer: HTMLDivElement

  private var selectedProductId = controller.products.first().productId.notNull("Missing product id")

  private val giftProductToggles = mutableListOf<GiftProductToggle>()

  override val root =
    controllerView {
      bg = background(image = Images.MEMBERSHIP)

      fg = foreground {
        centerHorizontally {
          div {
            screenWidthDependent { screendWidth ->
              width = px(if (screendWidth == PHONE) 330 else 500)
            }

            div {
              textAlign = CENTER
              marginTop = px(64)
              marginHorizontal = AUTO
              label(text = controller.giftSubtitle, fontSize = 18) {
                screenWidthDependent { screenWidth ->
                  fontSize = px(if (screenWidth == PHONE) 14 else 18)
                }
              }
            }

            div {
              textAlign = CENTER
              screenWidthDependent { screenWidth ->
                marginTop = px(if (screenWidth == PHONE) 10 else 30)
              }
              marginHorizontal = AUTO
              label(
                text = controller.giftTitle,
                fontSize = 24,
                fontWeight = MEDIUM
              ) {
                screenWidthDependent { screenWidth ->
                  fontSize = px(if (screenWidth == PHONE) 18 else 24)
                }
              }
            }

            div {
              screenWidthDependent { screenWidth ->
                marginTop = px(if (screenWidth == PHONE) 6 else 20)
                width = px(if (screenWidth == PHONE) 200 else 280)
              }

              marginHorizontal = AUTO
              display = FLEX
              justifyContent = SPACE_BETWEEN

              for (appType in MANIFEST.membershipConfig.singleAppTiles) {
                controller.getImage(appType)?.let {
                  div {
                    img {
                      screenWidthDependent { screenWidth ->
                        width = px(if (screenWidth == PHONE) 34 else 44)
                        height = px(if (screenWidth == PHONE) 34 else 44)
                      }
                      image = it
                    }
                  }
                }
              }
            }

            paymentOptionViewContainer = div {
              screenWidthDependent { screenWidth ->
                marginTop = px(if (screenWidth == PHONE) 10 else 40)
              }
              marginHorizontal = px(20)
              flexDirection = ROW
              display = FLEX
              justifyContent = SPACE_BETWEEN

              controller.products.forEach {
                giftProductToggles.add(
                  giftProductToggle(giftProduct = it)
                )
              }

              giftProductToggles.first().setBackgroundSelected(true)
            }

            // controller.alternateCurrencyCode?.let { alt ->
            //   centerHorizontally {
            //     marginTop = px(25)
            //     togglePill(
            //       lazyLeftText = { controller.config.defaultCurrencyCode!! },
            //       lazyRightText = { alt },
            //       getValue = { alternateCurrencySelected },
            //       onValueChanged = { right ->
            //         alternateCurrencySelected = right
            //         currencyCode = if (right) alt else controller.config.defaultCurrencyCode
            //         refreshView()
            //       }
            //     )
            //   }
            // }

            centerHorizontally {
              marginTop = px(3)

              div {
                width = percent(100)

                div {
                  paddingLeft = HORIZONTAL_CONTENT_GUTTER_PX
                  paddingRight = HORIZONTAL_CONTENT_GUTTER_PX

                  button {
                    screenWidthDependent { screenWidth ->
                      height = if (screenWidth == PHONE) px(50) else ROUNDED_TEXT_BUTTON_HEIGHT_PX
                      fontSize = px(if (screenWidth == PHONE) 15 else 19)
                      marginTop = px(if (screenWidth == PHONE) 10 else 35)
                    }
                    textContent = MANIFEST.membershipConfig.purchaseButtonText.uppercase()
                    width = percent(100)

                    borderRadius = ROUNDED_TEXT_BUTTON_HEIGHT_PX / 2
                    border = NONE

                    fontFamily = FONT_FAMILY
                    fontWeight = BOLD

                    bgColor = Color.DOWN_DOG_BLUE
                    txtColor = Color.WHITE

                    onClick {
                      controller.purchaseGift(productId = selectedProductId)
                    }
                  }
                }
              }

              verticalFlexBox {
                textAlign = TextAlign.LEFT
                screenWidthDependent { screenWidth ->
                  marginTop = px(if (screenWidth == PHONE) 15 else 30)
                  paddingHorizontal = px(if (screenWidth == PHONE) 15 else 30)
                }
                marginHorizontal = AUTO
                label(
                  text = Strings.GIFT_INSTRUCTIONS_TITLE,
                  fontSize = 20,
                  fontWeight = BOLD
                ) {
                  screenWidthDependent { screenWidth ->
                    fontSize = px(if (screenWidth == PHONE) 18 else 20)
                  }
                }

                ol {
                  txtColor = Color.WHITE
                  fontFamily = FONT_FAMILY
                  fontWeight = MEDIUM
                  screenWidthDependent { screenWidth ->
                    fontSize = px(if (screenWidth == PHONE) 14 else 16)
                  }
                  li {
                    text = Strings.GIFT_INSTRUCTIONS_CONTENT_1
                  }
                  li {
                    text = Strings.GIFT_INSTRUCTIONS_CONTENT_2
                    marginTop = px(10)
                  }
                  li {
                    text = Strings.GIFT_INSTRUCTIONS_CONTENT_3
                    marginTop = px(10)
                  }
                }
              }

              div {
                screenWidthDependent { screendWidth ->
                  width = px(if (screendWidth == PHONE) 300 else 450)
                }
                marginTop = px(15)
                textAlign = CENTER

                div {
                  label(
                    text = Strings.AMOUNTS_CURRENCY_PAYMENTS_SECURE_MESSAGE(currencyCode!!) + " " + Strings.RECEIPT_SENT_TO_EMAIL_MESSAGE(
                      MANIFEST.email!!
                    ),
                    fontSize = 12
                  ) {
                    txtColor = Color.white(0.85)
                    screenWidthDependent { screenWidth ->
                      fontSize = px(if (screenWidth == PHONE) 12 else 14)
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

  private fun HTMLDivElement.giftProductToggle(giftProduct: GiftProduct): GiftProductToggle {
    val toggle = GiftProductToggle(
      giftProduct = giftProduct,
      clickFn = {
        selectedProductId = giftProduct.productId
        giftProductToggles.forEach {
          it.setBackgroundSelected(selected = it.giftProduct == giftProduct)
        }
      }
    )

    toggle.setHeading(giftProduct.productTitle)
    giftProduct.productSubtitle?.let {
      toggle.setSubheading(it)
    }
    toggle.setPrice(giftProduct.price!!)
    toggle.setAppPrice(giftProduct.appPrice)

    this.appendChild(toggle.root)
    return toggle
  }

  private class GiftProductToggle(val giftProduct: GiftProduct, clickFn: GiftProductToggle.() -> Unit = {}) :
    AbstractView() {

    private var heading: HTMLSpanElement
    private var subheading: HTMLSpanElement
    private var appStorePrice: HTMLSpanElement
    private var price: HTMLSpanElement

    override val root = createDiv {
      screenWidthDependent { screenWidth ->
        width = px(if (screenWidth == PHONE) 135 else 217)
        height = px(if (screenWidth == PHONE) 175 else 220)
      }
      bgColor = Color.PRODUCT_TOGGLE_BACKGROUND
      borderRadius = px(8)
      marginHorizontal = px(5)

      centerHorizontally {
        height = percent(100)
        paddingHorizontal = px(10)
        textAlign = CENTER

        heading = label(
          text = null,
          fontWeight = SEMIBOLD,
          fontSize = 22
        ) {
          screenWidthDependent { screenWidth ->
            marginTop = px(if (screenWidth == PHONE) 30 else 39)
            fontSize = px(if (screenWidth == PHONE) 16 else 22)
          }
        }
        appStorePrice = label(
          text = null,
          fontSize = 20, // this is overridden in setAppPrice
          fontWeight = REGULAR
        ) {
          marginTop = px(15)
          style.textDecoration = "line-through"
          opacity = 0.8
          screenWidthDependent { screenWidth ->
            fontSize = px(if (screenWidth == PHONE) 13 else 20)
          }
        }
        price = label(
          text = null,
          fontSize = 30,
          fontWeight = SEMIBOLD
        ) {
          marginTop = px(4)
          screenWidthDependent { screenWidth ->
            fontSize = px(if (screenWidth == PHONE) 20 else 30)
          }
        }
        subheading = label(
          text = null,
          fontSize = 15
        ) {
          marginTop = px(12)
          opacity = 0.8
          screenWidthDependent { screenWidth ->
            fontSize = px(if (screenWidth == PHONE) 13 else 15)
          }
        }
      }

      onClick {
        clickFn()
        blur()
      }
    }

    fun setBackgroundSelected(selected: Boolean) {
      if (selected) {
        root.boxShadow = BoxShadow.boxShadow(px(0), px(0), px(0), px(4), true, Color.DOWN_DOG_BLUE)
      } else {
        root.boxShadow = BoxShadow.NONE
      }
    }

    fun setHeading(text: String) {
      heading.text = text
    }

    fun setSubheading(text: String?) {
      subheading.text = text
    }

    fun setAppPrice(priceStr: String?) {
      appStorePrice.text = priceStr ?: ""
    }

    fun setPrice(priceStr: String) {
      price.text = priceStr
    }
  }
}
